import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css, jsx } from '@emotion/react';
var truncateTextStyles = css({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
export var TruncateTextTag = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx("span", _extends({
    css: truncateTextStyles
  }, props, {
    ref: ref
  }), props.children);
});